module.exports = __webpack_public_path__ + "media/property_transaction_process/bank-e3de08ac.svg";